// removed by extract-text-webpack-plugin
module.exports = {"status":"_2oAOdsX14i4T6vbKv8qb4_","disabled":"_2G07fiBD7oo-3xEqDW3V9g","norm":"tQfsSpA6BWEFUHKoSRVyA","avar":"_2B1sP2rpjdp2v7j40d_8p0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/entries/StatusBA/style.css
// module id = 342
// module chunks = 0